import { useEffect, useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import { API } from "@/constants";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BrandStory from "@/components/BrandStory";
import JourneyMap from "@/components/JourneyMap";
import VideoStories from "@/components/VideoStories";
import Categories from "@/components/Categories";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const SECTION_COMPONENTS = {
  story: BrandStory,
  categories: Categories,
  journey: JourneyMap,
  videos: VideoStories,
};

const DEFAULT_LAYOUT = [
  { key: "story", visible: true },
  { key: "categories", visible: true },
  { key: "journey", visible: true },
  { key: "videos", visible: true },
];

export default function Landing() {
  const [layout, setLayout] = useState(DEFAULT_LAYOUT);

  useEffect(() => {
    axios
      .get(`${API}/homepage/layout`)
      .then((r) => {
        if (r.data?.sections?.length) setLayout(r.data.sections);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <main className="bg-white text-kera-ink font-body" data-testid="landing-page">
      <Seo />
      <Navbar />
      <Hero />
      <Marquee />
      {layout
        .filter((s) => s.visible)
        .map((s) => {
          const Component = SECTION_COMPONENTS[s.key];
          return Component ? <Component key={s.key} /> : null;
        })}
      <Footer />
    </main>
  );
}
